import script from "./ShowsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowsTable.vue?vue&type=script&setup=true&lang=js"

import "./ShowsTable.vue?vue&type=style&index=0&id=447e92c0&lang=css"

const __exports__ = script;

export default __exports__